// removed by extract-text-webpack-plugin
module.exports = {"field-customizer":"field-customizer__field-customizer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/encoding-pane/field-customizer.scss
// module id = 1217
// module chunks = 0